import { ConsultaAtendimentoPjRequest } from 'store/modules/api/procon/atendimentoCip/consultaAtendimentoPj/types';
import { ConsultaAtendimentosData } from 'store/modules/api/procon/atendimentos/consultaAtendimentos/types';

const getFirstValidInfoPayloadRequestConsultaAtendimentoPj = (
	data: ConsultaAtendimentoPjRequest,
) => {
	let payload: ConsultaAtendimentoPjRequest = {
		atendimentoId: '',
		protocolo: '',
		numeroFa: '',
	};

	if (data.atendimentoId) {
		payload = {
			...payload,
			atendimentoId: data.atendimentoId,
		};
		return payload;
	}

	if (data.protocolo) {
		payload = { ...payload, protocolo: data.protocolo };
		return payload;
	}

	if (data.numeroFa) {
		payload = { ...payload, numeroFa: data.numeroFa };
		return payload;
	}

	return null;
};

export const threatDataConsultaAtendimentoPjRequest = (
	requestData: ConsultaAtendimentosData,
): ConsultaAtendimentoPjRequest | null => {
	const valuesToThreat = {
		atendimentoId: requestData.atendimentoId,
		protocolo: requestData.protocolo,
		numeroFa: requestData.numeroFa || '',
	};

	const threatedValues =
		getFirstValidInfoPayloadRequestConsultaAtendimentoPj(valuesToThreat);

	return threatedValues;
};
